module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "22 12 18 12 15 21 9 3 6 12 2 12"
    }
  })])]), _vm._v("\n      Sales Volume\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('div', {
    staticClass: "time-filter"
  }, [_c('button', {
    staticClass: "time-filter-btn",
    class: {
      active: _vm.selectedPeriod === '7d'
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('7d')
      }
    }
  }, [_vm._v("7d")]), _vm._v(" "), _c('button', {
    staticClass: "time-filter-btn",
    class: {
      active: _vm.selectedPeriod === '30d'
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('30d')
      }
    }
  }, [_vm._v("30d")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    ref: "chartWrapper",
    staticClass: "chart-wrapper",
    on: {
      "mousemove": _vm.onMouseMove,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_c('canvas', {
    ref: "salesCanvas"
  }), _vm._v(" "), _c('div', {
    ref: "chartTooltip",
    staticClass: "chart-tooltip",
    class: {
      visible: _vm.tooltipVisible
    }
  }, [_c('div', {
    staticClass: "chart-tooltip-date"
  }, [_vm._v(_vm._s(_vm.tooltipDate))]), _vm._v(" "), _c('div', {
    staticClass: "chart-tooltip-value"
  }, [_vm._v(_vm._s(_vm.tooltipValue))]), _vm._v(" "), _c('div', {
    staticClass: "chart-tooltip-sub"
  }, [_vm._v(_vm._s(_vm.tooltipSub))])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-stats"
  }, [_c('div', {
    staticClass: "sales-stat"
  }, [_c('div', {
    staticClass: "sales-stat-label"
  }, [_vm._v("Daily Average")]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat-value"
  }, [_vm._v(_vm._s(_vm.dailyAverageValue) + " units")])]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat"
  }, [_c('div', {
    staticClass: "sales-stat-label"
  }, [_vm._v("Last 7 Days")]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat-value"
  }, [_vm._v(_vm._s(_vm.last7DaysValue) + " units "), _c('span', {
    staticClass: "trend",
    class: _vm.last7DaysChangeValue >= 0 ? 'up' : 'down'
  }, [_vm._v(_vm._s(_vm.last7DaysChangeValue >= 0 ? '↑' : '↓') + " " + _vm._s(Math.abs(_vm.last7DaysChangeValue)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat"
  }, [_c('div', {
    staticClass: "sales-stat-label"
  }, [_vm._v("Est. Monthly Revenue")]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.monthlyRevenueValue))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-849794dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/SalesVolumeChart.vue
// module id = 800
// module chunks = 2